import { render, staticRenderFns } from "./unset-restrict-shipout.vue?vue&type=template&id=38cf4b09&scoped=true"
import script from "./unset-restrict-shipout.vue?vue&type=script&lang=js"
export * from "./unset-restrict-shipout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf4b09",
  null
  
)

export default component.exports